import env from '../../../common/env';
import aiTutorConfig from '../config/aiTutor.config.json';

/**
 * Context fields driven by {@link env} `BERLIN_*` keys (see `src/common/env/*.js`).
 */
function buildEnvAiTutorContextPatch() {
  const patch = {};
  if (env.BERLIN_GRAPH_ID) {
    patch.indexId = env.BERLIN_GRAPH_ID;
    patch.bookID = env.BERLIN_GRAPH_ID;
    patch.secondaryBookId = env.BERLIN_GRAPH_ID;
  }
  if (env.BERLIN_TENANT_ID && env.BERLIN_TENANT_KEY) {
    const tenant = { tenantId: env.BERLIN_TENANT_ID, tenantKey: env.BERLIN_TENANT_KEY };
    patch.flashCardTenantObj = tenant;
    patch.berlinTenantObject = tenant;
  }
  return patch;
}

/**
 * Deep merge: nested objects merge; arrays and scalars from later sources win.
 */
export function deepMerge(target, ...sources) {
  const out = target && typeof target === 'object' && !Array.isArray(target) ? { ...target } : {};
  sources.forEach((src) => {
    if (src == null || typeof src !== 'object' || Array.isArray(src)) {
      return;
    }
    Object.keys(src).forEach((key) => {
      const sv = src[key];
      const ov = out[key];
      if (sv === undefined) {
        return;
      }
      if (sv && typeof sv === 'object' && !Array.isArray(sv) && ov && typeof ov === 'object' && !Array.isArray(ov)) {
        out[key] = deepMerge(ov, sv);
      } else {
        out[key] = sv;
      }
    });
  });
  return out;
}

/**
 * @param {object} [options]
 * @param {object} [options.context]
 * @param {object} [options.users]
 * @param {object} [options.agenticGraphConfig]
 * @param {object} [options.customThemeStyles]
 * @param {object} [options.customConfig]
 * @param {object} [options.chatProps]
 * @param {object} [options.launcher]
 * @param {string} [options.envName]
 */
export function buildAiTutorProps(options = {}) {
  const cfg = aiTutorConfig;

  const envContextPatch = buildEnvAiTutorContextPatch();
  const mergedContext = deepMerge(
    JSON.parse(JSON.stringify(cfg.context || {})),
    envContextPatch,
    options.context || {}
  );
  if (typeof mergedContext.chapterNumber === 'number' && !Number.isFinite(mergedContext.chapterNumber)) {
    delete mergedContext.chapterNumber;
  }

  const customThemeStyles = deepMerge(
    JSON.parse(JSON.stringify(cfg.customThemeStyles || {})),
    options.customThemeStyles || {}
  );

  const customConfig = deepMerge(JSON.parse(JSON.stringify(cfg.customConfig || {})), options.customConfig || {});

  const mergedUsers = deepMerge(JSON.parse(JSON.stringify(cfg.users || {})), options.users || {});

  const envAgenticPatch = env.BERLIN_GRAPH_ID ? { graphId: env.BERLIN_GRAPH_ID } : {};
  const agenticGraphConfig = deepMerge(
    JSON.parse(JSON.stringify(cfg.agenticGraphConfig || {})),
    envAgenticPatch,
    options.agenticGraphConfig || {}
  );

  const chatProps = deepMerge(JSON.parse(JSON.stringify(cfg.chatProps || {})), options.chatProps || {});

  const launcher = deepMerge(JSON.parse(JSON.stringify(cfg.launcher || {})), options.launcher || {});

  const envName = options.envName || cfg.env || 'qa';

  return {
    env: envName,
    users: mergedUsers,
    agenticGraphConfig,
    context: mergedContext,
    customThemeStyles,
    customConfig,
    chatProps,
    launcher,
    config: cfg
  };
}
